import { themeGet } from '@styled-system/theme-get'
import { Accordion, Box, Flex, Text, getPaletteColor } from 'pcln-design-system'
import { MenuItem } from 'pcln-menu'
import PropTypes from 'prop-types'
import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'

const HighlightSymbolItem = styled(MenuItem)`
  &:not(:hover) {
    & > :first-child {
      & > :first-child {
        color: ${getPaletteColor('primary.base')};
      }
    }
  }
`

const CurrencySelectorWrapper = styled(Box)`
  button {
    padding: ${themeGet('space.2')};
  }
`

function CurrencySelectorDropdown({ currencies, initialCurrency, onChange }) {
  const [currencyCode, setCurrencyCode] = useState(initialCurrency)
  const [itemsState, setState] = useState([])
  const onCurrencyChange = useCallback(
    (code) => {
      setCurrencyCode(code)
      handleToggle([])
      onChange && onChange(code)
    },
    [onChange]
  )
  const memoCurrencies = useMemo(
    () =>
      currencies &&
      currencies.map((currency) => {
        const selected = currency.code === currencyCode
        const onClick = () => onCurrencyChange(currency.code)
        return (
          <HighlightSymbolItem key={currency.code} mt={2} selected={selected} onClick={onClick}>
            <Text width={32} textAlign='center' regular mr={3}>
              {currency.symbol}
            </Text>
            <Text regular>{currency.label}</Text>
          </HighlightSymbolItem>
        )
      }),
    [currencies, currencyCode, onCurrencyChange]
  )
  
  const currenciesList = [
    {
      headerLabel: (
        <Text color={getPaletteColor('primary.base')} ml={2}>
          {currencyCode}
        </Text>
      ),
      content: <Flex flexDirection='column'>{memoCurrencies}</Flex>,
      value: 'dropdown',
    },
  ]

  const handleToggle = (newState) => {
    currenciesList.map((item) => {
      const open = newState.includes(item.value)
      open ? setState(['dropdown']) : setState([])
    })
  }

  return (
    <CurrencySelectorWrapper>
      <Accordion
        isExternallyControlled
        items={currenciesList}
        itemsState={itemsState}
        variation='link'
        onToggle={handleToggle}
      />
    </CurrencySelectorWrapper>
  )
}

CurrencySelectorDropdown.displayName = 'CurrencySelectorDropdown'

CurrencySelectorDropdown.propTypes = {
  currencies: PropTypes.array,
  initialCurrency: PropTypes.string,
  onChange: PropTypes.func,
}

CurrencySelectorDropdown.defaultProps = {
  initialCurrency: 'USD',
}

export default CurrencySelectorDropdown
